var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.54497 2.73005C5.96046e-08 3.79961 0 5.19974 0 8C0 10.8003 5.96046e-08 12.2004 0.54497 13.27C1.02433 14.2108 1.78924 14.9757 2.73005 15.455C3.79961 16 5.19974 16 8 16C10.8003 16 12.2004 16 13.27 15.455C14.2108 14.9757 14.9757 14.2108 15.455 13.27C16 12.2004 16 10.8003 16 8C16 5.19974 16 3.79961 15.455 2.73005C14.9757 1.78924 14.2108 1.02433 13.27 0.54497C12.2004 5.96046e-08 10.8003 0 8 0C5.19974 0 3.79961 5.96046e-08 2.73005 0.54497C1.78924 1.02433 1.02433 1.78924 0.54497 2.73005ZM11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4ZM4.9375 8C4.9375 6.3086 6.3086 4.9375 8 4.9375C9.6914 4.9375 11.0625 6.3086 11.0625 8C11.0625 9.6914 9.6914 11.0625 8 11.0625C6.3086 11.0625 4.9375 9.6914 4.9375 8Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ba8332b1d3efe65c6ddb3316b940ac67.svg";
export { ForwardRef as ReactComponent };